'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGeneratorReturnValue = exports.filterGeneratorYieldedValues = exports.generatorMapObject = exports.mapObject = exports.mapIterable = exports.isGenerator = exports.isIterable = exports.isUndefined = exports.isFunction = exports.invariant = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simple invariant check.
 *
 * @param {Boolean} A condition to be met
 *
 * @param {String} An exception message to be thrown
 * @returns {void}
 */
var invariant = exports.invariant = function invariant(condition, message) {
  if (!condition) {
    throw new Error('Invariant violation: ' + message);
  }
};

/**
 * Checks whether provided argument is a function.
 *
 * @param {any} Anything
 *
 * @returns {Boolean} Result of function check
 */
var isFunction = exports.isFunction = function isFunction(any) {
  return typeof any === 'function';
};

/**
 * Checks whether provided argument is undefined.
 *
 * @param {any} Anything
 *
 * @returns {Boolean} Result of undefined check
 */
var isUndefined = exports.isUndefined = function isUndefined(any) {
  return typeof any === 'undefined';
};

/**
 * Checks whether provided argument is iterable. The value must be defined and
 * must contain function named next.
 *
 * @param {any} Anything
 *
 * @returns {Boolean} Result of iterable check
 */
var isIterable = exports.isIterable = function isIterable(value) {
  return !isUndefined(value) && isFunction(value.next);
};

/**
 * Checks whether provided argument is generator.
 * The implementation is quite fragile. The current state
 * however does not allow reliable implementation of `isGenerator`
 * function.
 *
 * @param {any} Anything
 *
 * @returns {Boolean} Result of generator check
 */
var isGenerator = exports.isGenerator = function isGenerator(fn) {
  // Generator should never throw an exception because
  // it's not executed, only iterable is returned
  try {
    if (isFunction(fn)) {
      var result = fn();
      return !!result && isFunction(result._invoke);
    } else {
      return false;
    }
  } catch (ex) {
    return false;
  }
};

/**
 * Map implementation which takes iterable as an argument.
 *
 * @param {Iterable}
 *
 * @param {Function}
 * @returns {Array} Array mapped by mapper function
 */
var mapIterable = exports.mapIterable = function mapIterable(iterable, mapper) {
  invariant(isIterable(iterable), 'First argument passed to mapIterable must be iterable');

  invariant(isFunction(mapper), 'Second argument passed to mapIterable must be a function');

  // Clojure like recur loop
  // It's not ideal to use for..of as it does not
  // return the last value in iteration loop
  var recur = function recur(acc) {
    var next = iterable.next();
    acc.push(mapper(next));

    // ES6 tail call
    return next.done ? acc : recur(acc);
  };

  return recur([]);
};

/**
 * Standard map implementation which works with type of Object
 *
 * @param {Object} Object to be mapped
 *
 * @param {Function} Mapper function
 * @returns {Object} Mapped object
 */
var mapObject = exports.mapObject = function mapObject(object, fn) {
  return (0, _keys2.default)(object).reduce(function (memo, key) {
    memo[key] = fn(object[key], key);

    return memo;
  }, {});
};

/**
 * Standard map implementation which works with type of Object
 * and mapper in form of generator
 *
 * @param {Object} Object to be mapped
 *
 * @param {Function} Mapper function
 * @returns {Object} Mapped object
 */
var generatorMapObject = exports.generatorMapObject = _regenerator2.default.mark(function generatorMapObject(object, generatorFn) {
  var _marked, keys, recur;

  return _regenerator2.default.wrap(function generatorMapObject$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          recur = function recur(memo, index) {
            return _regenerator2.default.wrap(function recur$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.delegateYield(generatorFn(object[keys[index]], keys[index]), 't0', 1);

                  case 1:
                    memo[keys[index]] = _context.t0;

                    if (!keys[index + 1]) {
                      _context.next = 7;
                      break;
                    }

                    return _context.delegateYield(recur(memo, index + 1), 't2', 4);

                  case 4:
                    _context.t1 = _context.t2;
                    _context.next = 8;
                    break;

                  case 7:
                    _context.t1 = memo;

                  case 8:
                    return _context.abrupt('return', _context.t1);

                  case 9:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _marked[0], this);
          };

          _marked = [recur].map(_regenerator2.default.mark);

          invariant(isGenerator(generatorFn), 'First argument passed to filterGeneratorYieldedValues must be generator');

          keys = (0, _keys2.default)(object);
          return _context2.delegateYield(recur({}, 0), 't0', 5);

        case 5:
          return _context2.abrupt('return', _context2.t0);

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, generatorMapObject, this);
});

/**
 * Returns all the yield value within generator.
 *
 * @param {Object} Iterable created of generator
 *
 * @returns {Array} Array of yielded values
 */
var filterGeneratorYieldedValues = exports.filterGeneratorYieldedValues = function filterGeneratorYieldedValues(iterable) {
  invariant(isIterable(iterable), 'First argument passed to getGeneratorReturnValue must be an iterable');

  var recur = function recur(acc) {
    var next = iterable.next();
    if (next.done) {
      return acc;
    } else {
      acc.push(next.value);

      return recur(acc);
    }
  };

  return recur([]);
};

/**
 * Returns the returned value withing generator
 *
 * @param {Object} Iterable created of generator
 *
 * @returns {any} Value returned in generator
 */
var getGeneratorReturnValue = exports.getGeneratorReturnValue = function getGeneratorReturnValue(iterable) {
  invariant(isIterable(iterable), 'First argument passed to getGeneratorReturnValue must be generator');

  var recur = function recur() {
    var next = iterable.next();
    return next.done ? next.value : recur();
  };

  return recur();
};